import AboutImg from '../assets/about.png';
export default function about() {
  const config = {
    line1: 'A story of hard work and perseverance.',
    
    line3: 'My passion lies in designing engaging and efficient experiences that meet user needs and business goals. If you’re interested in working together or have any questions, feel free to reach out!.'
  }
    return (
      <section className=" flex flex-col md:flex-row  py-20 bg-white text-black about-all" id='about'>
        <div className=" md:w-1/2 abt-img ">
          <img src= {AboutImg} alt="About"/>
        </div>
        <div className=" about-ct font-hero-font flex-col  justify-center">
          <h6 className="font-light">LET ME INTRODUCE MYSELF</h6>
          <h2 className="text-4xl  font-bold mb-5">About Me</h2>
          <h6 className='font-bold'>{config.line1}</h6>
          <p>I'm a BCA graduate passout 2022, and I'm eager to dive into my passion for<span > Front-end and UI/UX Development.</span> After finishing my degree, I worked at Omega Healthcare as an AR Executive Processor, where I spent two years gaining valuable experience and sharpening my problem-solving skills. <br/> While at Omega, I also focused on developing key skills relevant to my field. Now, with a strong design background and a creative mindset, I’m excited to make the transition into tech. I’m skilled in <span>HTML, CSS, Bootstrap, Tailwind CSS, JavaScript, React.js, Git, GitHub, and version control, and have a solid grasp of UI/UX principles </span>. I’m looking forward to advancing my career and taking on new challenges in this dynamic industry.
          </p>
          <h6 className='font-bold'>Contact</h6>
          <p>{config.line3}</p>
          <div className="md:flex-row align-center py-5 space-x-5   about-btns">
          <button><a href='https://wa.me/6379517451' target='_blank' rel="noopener noreferrer"> Hire me</a></button>
          <button><a href='https://drive.google.com/file/d/1_K1nfpJdSWgXjXVwnBf9YBGsg2T7SrBc/view?usp=drive_link' target='_blank' rel="noopener noreferrer">Download CV</a></button>
        </div>
        </div>      
      </section>
    );
  }
  